export default "__VITE_ASSET__02bce072__"